import React, { useEffect, useState } from 'react';
import api from '../api';

export default function BlogsPage() {
  const [blogs, setBlogs] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [commentName, setCommentName] = useState('');
  const [commentEmail, setCommentEmail] = useState('');
  const [commentMessage, setCommentMessage] = useState('');
  const [submissionMessage, setSubmissionMessage] = useState('');

  useEffect(() => {
    api.get('/api/blogs').then((response) => setBlogs(response.data));
  }, []);

  const handleCommentSubmit = async (event) => {
    event.preventDefault();
    if (!selectedBlog) return;
    try {
      await api.post(`/api/blogs/${selectedBlog.id}/comments`, {
        blog_id: selectedBlog.id,
        author_name: commentName,
        author_email: commentEmail,
        message: commentMessage,
      });
      setSubmissionMessage('Comment submitted for approval.');
      setCommentName('');
      setCommentEmail('');
      setCommentMessage('');
    } catch (err) {
      setSubmissionMessage('Failed to submit comment.');
    }
  };

  return (
    <div className="blog-page">
      <h1>Blogs</h1>
      <div className="blog-layout">
        <aside className="blog-list">
          {blogs.map((blog) => (
            <button key={blog.id} type="button" onClick={() => setSelectedBlog(blog)}>
              {blog.title}
            </button>
          ))}
        </aside>
        <section className="blog-detail">
          {selectedBlog ? (
            <div>
              <h2>{selectedBlog.title}</h2>
              <p>{selectedBlog.summary}</p>
              <article>{selectedBlog.content}</article>
              <div className="comment-form">
                <h3>Leave a comment</h3>
                <form onSubmit={handleCommentSubmit}>
                  <label>
                    Name
                    <input type="text" value={commentName} onChange={(e) => setCommentName(e.target.value)} required />
                  </label>
                  <label>
                    Email
                    <input type="email" value={commentEmail} onChange={(e) => setCommentEmail(e.target.value)} required />
                  </label>
                  <label>
                    Comment
                    <textarea value={commentMessage} onChange={(e) => setCommentMessage(e.target.value)} required />
                  </label>
                  <button type="submit">Submit</button>
                </form>
                {submissionMessage && <p className="form-message">{submissionMessage}</p>}
              </div>
            </div>
          ) : (
            <p>Select a blog to read and comment.</p>
          )}
        </section>
      </div>
    </div>
  );
}
